export default __webpack_public_path__ + "static/media/envelope.156b07b9.svg";